module.exports = __webpack_public_path__ + "search-large.e6d62b530236eb83be27cab670644271.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search-large.svg
// module id = 1157
// module chunks = 0